import { render, staticRenderFns } from "./EfsStdMarginList.vue?vue&type=template&id=1f314379&scoped=true&"
import script from "./EfsStdMarginList.vue?vue&type=script&lang=js&"
export * from "./EfsStdMarginList.vue?vue&type=script&lang=js&"
import style0 from "./EfsStdMarginList.vue?vue&type=style&index=0&id=1f314379&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f314379",
  null
  
)

export default component.exports